import type { StepDefinition } from "@/shared/components/common/PropertyStepperScreen";
import type { LocalSupportingDocumentItem } from "@/features/protest/services/localSupportingDocuments.service";
import { SupportingDocumentsReviewSection } from "../SupportingDocumentsReviewSection";

export type ResidentialReviewStepPageProps = {
  residentialSteps: StepDefinition[];
  localSupportingDocuments: LocalSupportingDocumentItem[];
};

export const ResidentialReviewStepPage = ({
  residentialSteps,
  localSupportingDocuments,
}: ResidentialReviewStepPageProps) => {
  return (
    <SupportingDocumentsReviewSection
      steps={residentialSteps}
      localSupportingDocuments={localSupportingDocuments}
    />
  );
};
